import React, { useCallback } from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router';

import buttonStyles from './styles';

type Props = {
  path: string;
};

const GoBackButton = React.memo((props: Props) => {
  const classes = buttonStyles();
  let history = useHistory();

  const { path } = props;

  const goBack = useCallback(() => {
    history.push(path);
  }, [history, path]);

  return (
    <Tooltip title={'Back'} arrow>
      <IconButton onClick={goBack} className={classes.toggleIcon}>
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
  );
});

export default GoBackButton;
